import PropTypes from "prop-types";
import React from "react";
import OrgChart from "src/components/OrgChart";
import { ReactFlowContextProvider } from "src/contexts/reactFlowContext";
import { ModalProvider } from "src/contexts/withModal";

import { useAIDashboardStore } from "../context/AIDashboardContext";

const CanvOrgChart = ({ channel }) => {
  const store = useAIDashboardStore(channel);
  const value = store((state) => state.value?.id);

  return (
    (value && (
      <div style={{ height: "400px" }}>
        <ModalProvider>
          <ReactFlowContextProvider>
            <OrgChart teamId={value} />
          </ReactFlowContextProvider>
        </ModalProvider>
      </div>
    )) ||
    undefined
  );
};

CanvOrgChart.propTypes = {
  channel: PropTypes.string.isRequired,
};

export default CanvOrgChart;
